import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Simplified status config: only 'unpaid' and 'paid'
const statusConfig = {
  unpaid: {
    color: 'warning',
    labelKey: 'status.unpaid',
  },
  paid: {
    color: 'success',
    labelKey: 'status.paid',
  },
};

// Legacy status mapping for backward compatibility
const normalizeStatus = (status) => {
  if (status === 'uploaded' || status === 'viewed') {
    return 'unpaid';
  }
  if (status === 'downloaded') {
    return 'paid';
  }
  return status || 'unpaid';
};

const StatusBadge = ({ status, size = 'small', sx = {} }) => {
  const { t } = useTranslation();

  const normalizedStatus = normalizeStatus(status);
  const config = statusConfig[normalizedStatus] || statusConfig.unpaid;

  return (
    <Chip
      label={t(config.labelKey)}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500, ...sx }}
    />
  );
};

export default StatusBadge;
